import z from 'zod/v4';
import { EnumParams } from '../events.types';
import { imageSchema } from './event-shared-object.schema';

export const featuredContentSectionSchema = (enums?: EnumParams) =>
  z.object({
    primaryContent: imageSchema(enums),
    secondaryContent: imageSchema(enums).optional(),
  });
